import * as ResultsResearch from './resultsResearch.js';
export default ResultsResearch;
